"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("@8base-react/utils");
const TableSchemaContext_1 = require("./TableSchemaContext");
const withApplicationsList = (WrappedComponent) => {
    var _a;
    return _a = class WithApplicationsList extends react_1.default.Component {
            constructor() {
                super(...arguments);
                this.renderContent = ({ applicationsList }) => (react_1.default.createElement(WrappedComponent, Object.assign({}, this.props, { applicationsList: applicationsList })));
            }
            render() {
                return react_1.default.createElement(TableSchemaContext_1.TableSchemaContext.Consumer, null, this.renderContent);
            }
        },
        _a.displayName = `withApplicationsList(${utils_1.getDisplayName(WrappedComponent)})`,
        _a;
};
exports.withApplicationsList = withApplicationsList;
//# sourceMappingURL=withApplicationsList.js.map